import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { EuiLanguageSelectorModule } from '../eui-language-selector/language-selector.module';
import { EuiUserProfileModule } from '../eui-user-profile/user-profile.module';

import { EuiHeaderComponent } from './header.component';
import { EuiHeaderAppComponent,
         EuiHeaderAppNameDirective,
         EuiHeaderAppSubtitleDirective } from './header-app/header-app.component';
import { EuiHeaderEnvironmentComponent } from './header-environment/header-environment.component';
import { EuiHeaderLogoComponent } from './header-logo/header-logo.component';
import { EuiHeaderUserProfileComponent } from './header-user-profile/header-user-profile.component';
import { EuiHeaderAppNameComponent } from './header-app-name/header-app-name.component';
import { EuiHeaderAppSubtitleComponent } from './header-app-subtitle/header-app-subtitle.component';

const COMPONENTS = [
    EuiHeaderComponent,
    EuiHeaderComponent,
    EuiHeaderAppComponent,
    EuiHeaderAppNameComponent, EuiHeaderAppNameDirective,
    EuiHeaderAppSubtitleComponent, EuiHeaderAppSubtitleDirective,
    EuiHeaderEnvironmentComponent,
    EuiHeaderLogoComponent,
    EuiHeaderUserProfileComponent,
];

@NgModule({
    imports: [
        CommonModule, RouterModule,
        EuiUserProfileModule,
        EuiLanguageSelectorModule,
        RouterModule,
    ],
    declarations: [
        ...COMPONENTS,
    ],
    exports: [
        ...COMPONENTS,
    ],
})
export class EuiHeaderModule { }
